module.exports = __webpack_public_path__ + "static/presencial-maior-8caf5a4fa55af62cbd7fd9371831d391.jpg";